import React, { useState, useEffect } from "react";
import { Col, Typography, Row, Tag, Input } from "antd";
import { EyeFilled, SearchOutlined } from "@ant-design/icons";
import { getCandidateSkillListing } from "../../../redux/actions";
import "./candidateskillisting.css";
import SkillCard from "./SkillCard/SkillCard";
import MediaQuery from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/Loading/Loader";
import { useLocation } from "react-router-dom";
import { left } from "@antv/g2plot/lib/plots/sankey/sankey";

const CandidateSkillListing = (props) => {
  const { Text } = Typography;
  const dispatch = useDispatch();
  const location = useLocation();
  const userSkillListing = useSelector(
    (state) => state.skillListingReducer.skillListings
  );
  const loading = useSelector((state) => state.skillListingReducer.loading);
  useEffect(() => {
    dispatch(getCandidateSkillListing(location?.state?.id));
  }, []);
  return (
    <>
      <Col>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="line-divider"></div>
            <Col className="main-div-2" xs={24} >
                       <div>
                          <div span={6}  className="candidate-title" >
                <Text className="candidate-name" level={3}>                  
                {location?.state?.fname?.charAt(0)?.toUpperCase() + location?.state?.fname?.slice(1)}’s skill listing{userSkillListing?.data?.body?.count?.totalResult > 1 && `s`}
                </Text>
                <div className="item-count">
                      {userSkillListing?.data?.body?.count?.totalResult} item{userSkillListing?.data?.body?.count?.totalResult > 1 && `s`}
                             </div>
                             </div>
                <Row className="skill-card-container">
                  {userSkillListing?.data?.body?.data.map((items, index) => {
                    return <SkillCard key={index} {...items} />;
                  })}
                </Row>
              </div>
            </Col>
          </>
        )}
        {/* <div style={{padding:'10px'}}>
            <MediaQuery  maxWidth={768}>
               <Input
                type="input"
                placeholder="Find candidates"
                prefix={<SearchOutlined className="site-form-item-icon" />}
               //  onChange={onSearch}
               //  onKeyPress={(e) => onEnterKey(e)}
               ></Input>
            </MediaQuery>
         </div> */}
      </Col>
    </>
  );
};
export default CandidateSkillListing;
